import React from 'react'
import { Formik } from 'formik';
import * as yup from "yup";
import { Box, Button, Dialog, DialogContent, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import axios from 'axios';
import { formatDiscount } from '../../../global/formatter';

function RepurchaseDiscountCampaignDialog({ repurchaseCampaign, dialogOpen, handleClose }) {


    var initialValues = {
        one_month_come_back_discount_id: repurchaseCampaign?.one_month_come_back_discount_id || "",
        six_month_come_back_discount_id: repurchaseCampaign?.six_month_come_back_discount_id || "",
        one_year_come_back_discount_id: repurchaseCampaign?.one_year_come_back_discount_id || "",
    }

    var validationObject = {
        one_month_come_back_discount_id: yup.string(),
        six_month_come_back_discount_id: yup.string(),
        one_year_come_back_discount_id: yup.string(),
    }

    const campaignSchema = yup.object().shape(validationObject);

    const handleFormSubmit = async (values) => {
        await axios.patch(`${process.env.REACT_APP_API_URL}settings/updateRepurchaseCampaign`, {
            ...values
        }).catch((err) => {
            console.log("err: " + err);
        }).then((response) => {
            if (response && response.data.success === true && response.data.status === 200) {
                handleClose()
            }
        });

    }

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            sx={{ margin: "0 auto" }}
            open={dialogOpen}
            onClose={() => handleClose()}>
            <Box mx="20px" mt="20px" textAlign="center">
                <Typography variant='h3'>
                    Repurchase Campaigns
                </Typography>
            </Box>
            <DialogContent>
                <Box>
                    <Formik
                        onSubmit={handleFormSubmit}
                        initialValues={initialValues}
                        validationSchema={campaignSchema}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <Box display="grid" gap="15px" gridTemplateColumns="repeat(4, minmax(0, 1fr))" mx="75px" mb="25px">

                                    <FormControl fullWidth variant="filled" sx={{ marginTop: "10px", gridColumn: "span 4" }}>
                                        <InputLabel id="filter-label">1 Month Subscription Price</InputLabel>
                                        <Select
                                            labelId="filter-label"
                                            label="Type"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            name={"one_month_come_back_discount_id"}
                                            value={values.one_month_come_back_discount_id}
                                            error={!!touched.one_month_come_back_discount_id && !!errors.one_month_come_back_discount_id}
                                        >
                                            <MenuItem value={""}>None</MenuItem>
                                            <MenuItem value={"p1mtier1discount"}>{formatDiscount("p1mtier1discount")}</MenuItem>
                                            <MenuItem value={"p1mtier2discount"}>{formatDiscount("p1mtier2discount")}</MenuItem>
                                            <MenuItem value={"p1mtier3discount"}>{formatDiscount("p1mtier3discount")}</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <FormControl fullWidth variant="filled" sx={{ marginTop: "10px", gridColumn: "span 4" }}>
                                        <InputLabel id="filter-label">6 Months Subscription Price</InputLabel>
                                        <Select
                                            labelId="filter-label"
                                            label="Type"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            name={"six_month_come_back_discount_id"}
                                            value={values.six_month_come_back_discount_id}
                                            error={!!touched.six_month_come_back_discount_id && !!errors.six_month_come_back_discount_id}
                                        >
                                            <MenuItem value={""}>None</MenuItem>
                                            <MenuItem value={"p6mtier1discount"}>{formatDiscount("p6mtier1discount")}</MenuItem>
                                            <MenuItem value={"p6mtier2discount"}>{formatDiscount("p6mtier2discount")}</MenuItem>
                                            <MenuItem value={"p6mtier3discount"}>{formatDiscount("p6mtier3discount")}</MenuItem>
                                            <MenuItem value={"p6mtier4discount"}>{formatDiscount("p6mtier4discount")}</MenuItem>
                                            <MenuItem value={"p6mtier6discount"}>{formatDiscount("p6mtier6discount")}</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <FormControl fullWidth variant="filled" sx={{ marginTop: "10px", gridColumn: "span 4" }}>
                                        <InputLabel id="filter-label">1 Year Subscription Price</InputLabel>
                                        <Select
                                            labelId="filter-label"
                                            label="Type"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            name={"one_year_come_back_discount_id"}
                                            value={values.one_year_come_back_discount_id}
                                            error={!!touched.one_year_come_back_discount_id && !!errors.one_year_come_back_discount_id}
                                        >
                                            <MenuItem value={""}>None</MenuItem>
                                            <MenuItem value={"p1ytier1discount"}>{formatDiscount("p1ytier1discount")}</MenuItem>
                                            <MenuItem value={"p1ytier2discount"}>{formatDiscount("p1ytier2discount")}</MenuItem>
                                            <MenuItem value={"p1ytier3discount"}>{formatDiscount("p1ytier3discount")}</MenuItem>
                                            <MenuItem value={"p1ytier4discount"}>{formatDiscount("p1ytier4discount")}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box display="flex" justifyContent="end" m="20px 20px 0px 20px">
                                    <Button type="submit" color="secondary" variant="contained">
                                        <Typography variant='h5'>Save</Typography>
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog >
    )
}

export default RepurchaseDiscountCampaignDialog